export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001/api"
    : "https://link.jamx.ai:3100/api";

export const AUXIGEN_API_URL = "https://api.auxigen.io";

export const adsTxtFixed = (group_id, display_id) => `
jamx.ai, ${group_id || 0}, DIRECT
audiopulsar.com, ${group_id || 0}, DIRECT
podium-audio.com, ${group_id || 0}, DIRECT`;

export const limitedAdminPages = [
  // "AdminDashboard",
  // "AdminNewDashboard",
  "AdminGroupsList",
  "CustomReports",
  "AdminSellers",
  "AdminPublisherOnboardingLinks",
  "AdminReportSchedules",
  "AdminUpdateSellerGroup",
  "AdminAddSeller",
  "AdminUpdateSeller",
  "AdminAddScheduledReport",
];

export const hostedOptionsSet = [
  { name: "Self", value: "self" },
  { name: "Simplecast Jamx", value: "simplecast_jx" },
  { name: "Simplecast Pulsar", value: "simplecast_ps" },
  { name: "Simplecast NeonNights", value: "simplecast_nn" },
  { name: "Omny", value: "omny" },
  { name: "Soundstack", value: "soundstack" },
  { name: "Libsyn", value: "libsyn" },
  { name: "Spreaker", value: "spreaker" },
  { name: "Demo", value: "demo" },
  { name: "Megaphone", value: "megaphone" },
  { name: "Acast", value: "acast" },
  { name: "Art-19", value: "art_19" },
  { name: "Megaphone Launchpod", value: "megaphone_launchpod" },
];

export const podcasterTypeOptions = [
  { label: "Individual", value: "individual" },
  { label: "Network", value: "network" },
  { label: "Publisher", value: "publisher" },
];
export const podcasterPlanOptions = [
  { label: "Trial", value: "trial" },
  { label: "Jamx Network", value: "jamx network" },
  { label: "Self", value: "self" },
];

export const AUXIGEN_TASK_STAGES = {
  PROCESSING_INTRO_OUTRO: "intro_outro_audio",
  GENERATING_SHOW_METADATA: "metadata",
  GENERATING_TRANSCRIPTS: "transcripts",
  GENERATING_EPISODES_AUDIO: "episodes_audio",
};

export const AUXIGEN_STAGE_LABELS = {
  [AUXIGEN_TASK_STAGES.PROCESSING_INTRO_OUTRO]: "Processing intro/outro audio",
  [AUXIGEN_TASK_STAGES.GENERATING_SHOW_METADATA]: "Generating show metadata",
  [AUXIGEN_TASK_STAGES.GENERATING_TRANSCRIPTS]: "Generating transcripts",
  [AUXIGEN_TASK_STAGES.GENERATING_EPISODES_AUDIO]: "Generating episodes audio",
};

export const MAX_AVG_MONTHLY_DOWNLOADS = 1_000_000_000;

export const PODCASTER_JOIN_NETWORK_EMAIL_TEMPLATES = {
  WAITING_LIST: {
    label: "Waiting List",
    value: "podcaster-waiting-list",
    requires: [],
  },
  CALENDAR_LINK: {
    label: "Calendar Link",
    value: "podcaster-calendar-link",
    requires: ["url"],
  },
  CALENDAR_LINK_STATIC: {
    label: "Calendar Link",
    value: "podcaster-calendar-link-static",
    requires: [],
  },
  CONTRACT_LINK: {
    label: "Contract Link",
    value: "podcaster-contract-link",
    requires: ["url"],
  },
};

export const DAYS_OF_WEEK = [
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
  { label: "Sunday", value: 7 },
];

export const MUSIC_CATEGORIES = [
  { label: "Happy", value: "happy" },
  { label: "Sad", value: "sad" },
  { label: "Serious", value: "serious" },
];

export const GENDER = {
  MALE: "male",
  FEMALE: "female",
  UNISEX: "unisex",
};

export const AVATAR_VOICE_GENDER_MAPPING = {
  openai: {
    onyx: GENDER.MALE,
    echo: GENDER.MALE,
    ash: GENDER.MALE,
    ballad: GENDER.MALE,
    cedar: GENDER.MALE,
    verse: GENDER.MALE,
    nova: GENDER.FEMALE,
    shimmer: GENDER.FEMALE,
    coral: GENDER.FEMALE,
    marin: GENDER.FEMALE,
    alloy: GENDER.UNISEX,
    sage: GENDER.UNISEX,
    fable: GENDER.UNISEX,
  },
  gemini_2_5: {
    Achird: GENDER.MALE,
    Algenib: GENDER.MALE,
    Algieba: GENDER.MALE,
    Alnilam: GENDER.MALE,
    Charon: GENDER.MALE,
    Enceladus: GENDER.MALE,
    Fenrir: GENDER.MALE,
    Iapetus: GENDER.MALE,
    Orus: GENDER.MALE,
    Puck: GENDER.MALE,
    Rasalgethi: GENDER.MALE,
    Sadachbia: GENDER.MALE,
    Sadaltager: GENDER.MALE,
    Schedar: GENDER.MALE,
    Umbriel: GENDER.MALE,
    Zubenelgenubi: GENDER.MALE,
    Achernar: GENDER.FEMALE,
    Aoede: GENDER.FEMALE,
    Autonoe: GENDER.FEMALE,
    Callirrhoe: GENDER.FEMALE,
    Despina: GENDER.FEMALE,
    Erinome: GENDER.FEMALE,
    Gacrux: GENDER.FEMALE,
    Kore: GENDER.FEMALE,
    Laomedeia: GENDER.FEMALE,
    Leda: GENDER.FEMALE,
    Pulcherrima: GENDER.FEMALE,
    Sulafat: GENDER.FEMALE,
    Vindemiatrix: GENDER.FEMALE,
    Zephyr: GENDER.FEMALE,
  },
};
